/**
 * Hotkeys
 */

import React from 'react';
import Hotkeys from 'react-hot-keys';
import { VoidFunction } from '../types';

export type HotkeyProps = {
  triggerUndo: VoidFunction;
  triggerRedo: VoidFunction;
};

const Hotkey: React.FC<HotkeyProps> = props => {
  return (
    <div>
      <Hotkeys keyName="control+z,command+z" onKeyDown={props.triggerUndo} />
      <Hotkeys keyName="control+shift+z,command+shift+z" onKeyDown={props.triggerRedo} />
    </div>
  );
};

export default Hotkey;
